import React, { useRef, useState, useCallback } from "react";
import { SlideInSelection } from "slideinselection";
import { CartItemsList } from "wbm-cart-items-list";
import CartTotals from "./cartTotals";
import Budget from "./budget";
import Workflow from "./workflow";
import EventService from "./eventService";

const WBMCartSlideInSelection = ({
  cartTrigger,
  header,
  cartTotals,
  shoppingCartUrl,
  editShoppingCartUrl,
  checkoutUrl,
  removeItemCallback,
  cartItems,
  budget,
  workflow,
  adobeEventsConfig,
  checkoutButtonText,
  appendRemoveContainerWidth,
  isCookied,
  forceOpen,
  closeCallback,
  ecomUrl,
  ...props
}) => {
  const SIS = useRef(null);
  const [selectDoneHeight, setSelectDoneHeight] = useState(0);
  const selectDoneRef = useCallback(
    (node) => {
      if (node !== null) {
        setSelectDoneHeight(node.getBoundingClientRect().height);
      }
    },
    [budget, cartTotals]
  );

  const isWorkflow = workflow && workflow.isWorkflow;

  const closeComponent = () => {
    SIS.current.slideItOut();
  };

  const handleCheckout = () => {
    if (adobeEventsConfig && adobeEventsConfig.proceedToCheckout) {
      const proceedToCheckout = "proceedToCheckout";
      window.digitalData.eCommerce.productInfo = cartItems.map((item) => {
        return {
          productSKU: item.sku ? item.sku : "",
          productName: item.description,
        };
      });
      window.digitalData.eventInfo.event = proceedToCheckout;
      EventService.emitCustomEvent(proceedToCheckout);
    }

    // must return true for the href to execute afterwards
    return true;
  };

  const handleOnOpen = () => {
    if (adobeEventsConfig && adobeEventsConfig.cartViewed) {
      window.digitalData.eventInfo.event = "cartViewed";
    }
  };

  return (
    <div
      className={
        "cart-slide-in" +
        (isWorkflow ? " workflow-cart" : "") +
        (cartItems && cartItems.length > 0 ? " has-items" : "")
      }
    >
      <SlideInSelection
        forceOpen={forceOpen}
        ref={SIS}
        button={cartTrigger(closeComponent)}
        header={header}
        containerId={props.containerId}
        onOpen={handleOnOpen}
        appendRemoveContainerWidth={appendRemoveContainerWidth}
        backgroundColor={props.backgroundColor}
        closeCallback={() => {
          if (closeCallback) {
            closeCallback();
          }
        }}
      >
        <div
          className="container cart-items-container"
          style={{
            bottom: selectDoneHeight,
            top: 48, // fixed height for top
          }}
        >
          {isWorkflow && <Workflow workflow={workflow} isCookied={isCookied} />}
          <CartItemsList
            cartItems={cartItems}
            shoppingCartUrl={editShoppingCartUrl}
            removeItemCallback={removeItemCallback}
            useMobile
            closeComponent={closeComponent}
            ecomUrl={ecomUrl}
            {...props}
          />
        </div>
        <div className="select-done" ref={selectDoneRef}>
          {budget &&
            budget.displayBudgetDetailsWhileShopping &&
            (budget.remainingBudget < 0 || budget.forceOverBudget) && (
              <>
                <div className="over-budget-banner">Order Over Budget</div>
                <br />
              </>
            )}
          <CartTotals orderTotals={cartTotals} />
          {budget && budget.displayBudgetDetailsWhileShopping && (
            <Budget
              availableBudget={budget.availableBudget}
              remainingBudget={budget.remainingBudget}
            />
          )}
          <div className="row">
            <div className="col-4 pr-0">
              <a
                role="button"
                className="btn btn-lg btn-outline-primary view-cart"
                href={shoppingCartUrl}
              >
                VIEW CART
              </a>
            </div>
            <div className="col-8 no-padding-right">
              <a
                href={checkoutUrl}
                role="button"
                type="button"
                className={
                  "btn btn-lg btn-primary " +
                  (cartItems.length === 0 ? "disabled" : "")
                }
                onClick={handleCheckout}
                aria-disabled={cartItems.length === 0}
              >
                {checkoutButtonText
                  ? checkoutButtonText.toUpperCase()
                  : "CHECKOUT"}
              </a>
            </div>
          </div>
        </div>
      </SlideInSelection>
    </div>
  );
};

export default WBMCartSlideInSelection;
